<template>
  <power-wrapper :CurrRole="CurrRole">
    <div class="distributorList">
      <h3>成员管理</h3>
      <div class="refresh">为团队添加成员，添加之后成员通过手机号加短信验证码能登录联盟系统</div>
      <el-button class="button-style" type="primary" icon="el-icon-plus" @click="create">添加成员</el-button>
      <el-table v-loading="listLoading" :data="list" border fit highlight-current-row :header-cell-style="tableHeader">
        <el-table-column label="姓名" align="center">
          <template slot-scope="{row}">
            <span>{{ row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="登录手机号" align="center">
          <template slot-scope="{row}">
            <span>{{ row.phone }}</span>
          </template>
        </el-table-column>
        <el-table-column label="角色" align="center">
          <template slot-scope="{row}">
            <span>{{ row.teamRole ? row.teamRole === 1 ? '创建者' : row.teamRole === 2 ? '管理员' : '普通成员' : '普通成员' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="{row}">
            <span>{{ row.agentStatus ? '停用' : '启用' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="添加时间">
          <template slot-scope="{row}">
            <span>{{ row.ctime ? timestampToDate(row.ctime) : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="240px">
          <template slot-scope="{row}">
            <el-button v-if="(row.teamRole && Number(row.teamRole) === 1 && isManager && Number(isManager) === 1) || Number(row.teamRole) !== 1" type="text" size="mini" @click="edit(row)" class="btnsStyle">编辑</el-button>
            <el-button v-if="isManager && Number(row.teamRole) !== 1" type="text" size="mini" @click="manage(row)" class="btnsStyle">{{row.teamRole === 2 ? '取消管理员' : row.teamRole === 1 ? '' : '设为管理员'}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog :title="isEdit ? '编辑成员' : '添加成员'" :visible.sync="dialogVisible" width="605px" :before-close="cancelDialog">
        <el-form :model="editQuery" :rules="LevelSRules" label-width="110px" ref="mermberRef">
          <el-form-item prop="name" label="姓名">
            <el-input v-clear-emoij v-model="editQuery.name" placeholder="请输入成员名称" class="selectWidth" />
          </el-form-item>
          <el-form-item v-if="isEdit" prop="pho" label="登录手机号">
            <span>{{editQuery.phone || '--'}}</span>
          </el-form-item>
          <el-form-item v-else prop="phoneNum" label="登录手机号">
            <el-input
              type="number"
              onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))"
              v-model.number="editQuery.phoneNum"
              placeholder="请输入成员手机号"
              maxlength="11"
              autocomplete="on"
              @input="checkLength"
              class="selectWidth numrule"
            />
            <div style="color:red">用来登录系统，务必保证手机号正确</div>
          </el-form-item>
          <el-form-item prop="agentStatus" label="状态" v-if="!isEdit || (isEdit && editQuery.agentCode !== accountAgentCode)">
            <el-radio-group v-model="editQuery.agentStatus">
              <el-radio :label="0">启用</el-radio>
              <el-radio :label="1">停用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelDialog">取 消</el-button>
          <el-button type="primary" @click="confirmDialog()">保 存</el-button>
        </span>
      </el-dialog>
      <el-dialog :title="manageTitle ? '取消管理员' : '设置管理员'" :visible.sync="manageVisible" width="460px" :before-close="cancelManageDialog">
        <div class="manage-style">确定将「{{manageObj.name || ''}}」{{manageTitle ? '从管理员中移除？' : '设置成管理员?'}}</div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelManageDialog">取 消</el-button>
          <el-button type="primary" @click="manegeDialog()">保 存</el-button>
        </span>
      </el-dialog>
    </div>
  </power-wrapper>
</template>

<script>
import Cookie from 'js-cookie';
import { getMemberList, editProduct, addProduct, modifyAdmin } from "@/services/member";
import PowerWrapper from "@/components/PowerWrapper";
import { delUndefined, numFormat, timestampToDateTotal } from "@/utils/utils";
import { getTeamCode, getAgentCode, getTeamRole } from '@/utils/auth'

export default {
  name: "member",
  components: {
    PowerWrapper
  },
  data() {
    return {
      CurrRole: "member",
      list: [],
      listQuery: {
        current: 1,
        pageSize: 10,
        orderId: null,
        userId: null,
        productName: null,
        status: null,
        productType: 1,
        payTime: 1,
        startTime: null,
        endTime: null
      },
      listLoading: false,
      dialogVisible: false,
      manageVisible: false,
      editQuery: {
        id: null,
        name: null,
        phone: null,
        phoneNum: null,
        agentStatus: 0,
        agentCode: null,
        createAgentCode: null
      },
      LevelSRules: {
        name: [
          { required: true, message: "请输入姓名", trigger: ['blur', 'change'] }
        ],
        phoneNum: [
          { required: true, message: "请输入登录手机号", trigger: ['blur', 'change'] },
          {
            validator: (rule, val, cb) => {
              const regex = /^1[3-9]\d{9}$/;
              if (val && !regex.test(val)) {
                cb(new Error('请输入正确的手机号'))
              } else {
                cb()
              }
            },
            trigger: ['blur']
          }
        ],
        agentStatus: [
          { required: true, message: "请选择状态", trigger: ['blur', 'change'] }
        ],
      },
      flag: 1,
      isEdit: false,
      manageTitle: false,
      manageObj: {}
    };
  },
  computed: {
    tableHeader() {
      return () => {
        return { 'background-color': '#f5f5f5' }
      }
    },
    isManager() {
      return getTeamRole()
    },
    accountAgentCode() {
      return getAgentCode()
    },
  },
  created() {
    this.getList()
  },
  methods: {
    checkLength (e) {
      if (e.length > 11) {
        this.editQuery.phoneNum = e.slice(0, 11)
      }
    },
    timestampToDate(time) {
      return timestampToDateTotal(time)
    },
    numberFormat(num) {
      return numFormat(num)
    },
    getList(btnName) {
      this.listLoading = true;
      const params = {
        teamCode: getTeamCode(),
        teamRole: getTeamRole() ? Number(getTeamRole()) : 0
      }
      getMemberList(delUndefined(params)).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.listLoading = false;
          this.list = res.data.data;
          if (btnName === 'search') {
            this.listQuery.current = 1;
          }
        } else if (res.data && res.data.errCode === 1016) {
          this.$message({ type: 'error', message: '登录时效已过期，请重新登录' })
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.listLoading = false;
          this.list = [];
        }
      });
    },
    handleSearch() {
      this.getList('search');
    },
    create() {
      this.isEdit = false;
      if (this.$refs.mermberRef) this.$refs.mermberRef.resetFields();
      this.dialogVisible = true;
      // 清空数据
      this.editQuery.id = null;
      this.editQuery.agentStatus = 0
      this.editQuery.name = null;
      this.editQuery.phone = null;
      this.editQuery.phoneNum = null;
      this.editQuery.agentCode = null;
    },
    edit(item) {
      this.isEdit = true;
      this.dialogVisible = true;
      this.editQuery.id = item.id;
      this.editQuery.name = item.name;
      this.editQuery.phone = item.phone;
      this.editQuery.phoneNum = item.phone;
      this.editQuery.agentStatus = item.agentStatus;
      this.editQuery.agentCode = item.agentCode;
      if (this.$refs.mermberRef) this.$refs.mermberRef.clearValidate('phoneNum')
    },
    manage(item) {
      if (getTeamRole() && Number(getTeamRole()) === 2) {
        this.$message({ type: 'error', message: '只有「创建者」能设置和取消管理员' })
      } else {
        this.manageVisible = true;
        this.manageTitle = item && item.teamRole && item.teamRole === 2;
        this.manageObj = item;
      }
    },
    cancelDialog() {
      this.dialogVisible = false;
    },
    cancelManageDialog() {
      this.manageVisible = false;
    },
    confirmDialog() {
      const { editQuery } = this
      this.$refs.mermberRef.validate(async (valid) => {
        if (valid) {
          const { phoneNum, name, id, agentStatus, agentCode } = editQuery
          const params = {
            name,
            phone: phoneNum,
            agentStatus,
            teamCode: getTeamCode(),
            createAgentCode: getAgentCode()
          }
          if (this.isEdit) { // 编辑
            editProduct({
              type: 'PUT',
              params: {
                id: id ? Number(id) : null,
                name,
                agentStatus,
                teamCode: getTeamCode(),
                createAgentCode: getAgentCode(),
                agentCode
              }
            }).then(res => {
              if (res.data && res.data.errCode === 0) {
                this.$message({ type: 'success', message: "编辑成员信息成功" })
                this.getList();
                this.dialogVisible = false;
              } else if (res.data && res.data.errCode === 1016) {
                this.$message({ type: 'error', message: '登录时效已过期，请重新登录' })
                Cookie.remove('staffToken')
                setTimeout(() => {
                  this.$router.push({ path: '/login' })
                }, 3000)
              } else {
                this.$message({ type: 'error', message: res.data.errMsg })
              }
            })
          } else {
            addProduct({
              type: 'POST',
              params: {
                ...delUndefined(params)
              }
            }).then(res => {
              if (res.data && res.data.errCode === 0) {
                this.$message({ type: 'success', message: "添加成功" })
                this.getList();
                this.dialogVisible = false;
              } else if (res.data && res.data.errCode === 1016) {
                this.$message({ type: 'error', message: '登录时效已过期，请重新登录' })
                Cookie.remove('staffToken')
                setTimeout(() => {
                  this.$router.push({ path: '/login' })
                }, 3000)
              } else {
                this.$message({ type: 'error', message: res.data.errMsg })
              }
            })
          }
        } else {
          this.$message({ type: 'error', message: "请完整填写信息" })
        }
      })
    },
    manegeDialog() {
      const { manageObj } = this;
      const { agentCode, teamCode, teamRole } = manageObj
      modifyAdmin({
        type: 'PUT',
        params: {
          agentCode: getAgentCode(),
          modifyAgentCode: agentCode,
          teamCode,
          teamRole: teamRole ? 0 : 2
        }
      }).then(res => {
        if (res.data && res.data.errCode === 0) {
          this.$message({ type: 'success', message: teamRole ? "取消管理员成功" : "设为管理员成功" })
          this.getList();
          this.manageVisible = false;
        } else if (res.data && res.data.errCode === 1016) {
          this.$message({ type: 'error', message: '登录时效已过期，请重新登录' })
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.$message({ type: 'error', message: res.data.errMsg })
        }
      })
    },
  }
};
</script>

<style lang="less" scoped>
@import '../../styles/common.less';
.exportExcel {
  float: right;
  margin-bottom: 10px;
}
.distributorList {
  position: relative;
  .btnsStyle{
    display: inline-block;
    color:#FF9900;
    width: 85px;
  }
  .selectWidth{
    width: 300px;
  }
  .colorStyle{
    display: inline-block;
    color:#FF9900;
  }
  .inputWidth{
    width: 380px;
  }
  .blue{
    color:#409EFF;
  }
}
.manage-style{
  text-align: center;
}
</style>
